import * as types from "@/redux/types";

const initialState = { show: true };

export const loadingReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case types.HIDE_LOADING_LOADER: return { show: false };

        case types.SHOW_LOADING_LOADER: return { show: true };

        default: return state;
    }
};
